import React, { useState } from 'react';

interface Member {
  id: string;
  name: string;
}

interface AddBoxModalProps {
  open: boolean;
  onClose: () => void;
  members: Member[];
  onAddBox: (box: [string, string, string]) => void;
}

const AddBoxModal: React.FC<AddBoxModalProps> = ({ open, onClose, members, onAddBox }) => {
  const [first, setFirst] = useState('');
  const [second, setSecond] = useState('');
  const [third, setThird] = useState('');

  const handleAddBox = () => {
    if (first && second && third && first !== second && first !== third && second !== third) {
      onAddBox([first, second, third]);
      setFirst('');
      setSecond('');
      setThird('');
      onClose();
    }
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white rounded-lg border border-brand-200 p-6 w-full max-w-sm">
        <h2 className="text-xl font-bold mb-4">Aggiungi Box (3 partecipanti)</h2>
        <div className="mb-3 space-y-2">
          <select
            className="w-full p-2 border rounded"
            value={first}
            onChange={e => setFirst(e.target.value)}
          >
            <option value="" disabled>Seleziona primo partecipante</option>
            {members.map(m => (
              <option key={m.id} value={m.id}>{m.name}</option>
            ))}
          </select>
          <select
            className="w-full p-2 border rounded"
            value={second}
            onChange={e => setSecond(e.target.value)}
          >
            <option value="" disabled>Seleziona secondo partecipante</option>
            {members.filter(m => m.id !== first).map(m => (
              <option key={m.id} value={m.id}>{m.name}</option>
            ))}
          </select>
          <select
            className="w-full p-2 border rounded"
            value={third}
            onChange={e => setThird(e.target.value)}
          >
            <option value="" disabled>Seleziona terzo partecipante</option>
            {members.filter(m => m.id !== first && m.id !== second).map(m => (
              <option key={m.id} value={m.id}>{m.name}</option>
            ))}
          </select>
        </div>
        <div className="flex justify-end gap-2 mt-4">
          <button
            className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
            onClick={onClose}
          >
            Annulla
          </button>
          <button
            className="px-4 py-2 bg-brand-600 text-white rounded hover:bg-brand-700 disabled:opacity-50"
            onClick={handleAddBox}
            disabled={!first || !second || !third || first === second || first === third || second === third}
          >
            Aggiungi Box
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddBoxModal;
